import {appendQueryString, getExternalRequest} from "@pg-mono/request";
import {apiBigDataLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../../app/api/rp_api";
import {bigDataApiUrl} from "../../../app/read_rp_environment_variables";
import {IFetchPropertyEstimatedPriceRequestParams, IPropertyEstimatedPrice} from "../../../property/actions/fetch_property_estimated_price";

export type IGetPropertyEstimatedPricesQuery = Omit<IFetchPropertyEstimatedPriceRequestParams, "scenario" | "date_start" | "date_end"> & {
    date_start?: string;
    date_end?: string;
};

export const propertyEstimatedPricesApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getPropertyEstimatedPrices: builder.query<IPropertyEstimatedPrice[], IGetPropertyEstimatedPricesQuery>({
            queryFn: async (query) => {
                const fullQuery = {...query, scenario: "rp-price-avg"};
                const endpointLink = query.slug_district ? apiBigDataLink.monthDistrictsStats.base : apiBigDataLink.monthCityStats.base;
                const url = appendQueryString(endpointLink(bigDataApiUrl), fullQuery);

                return getExternalRequest({}, url, 5000)
                    .then((response: IPropertyEstimatedPrice[]) => ({data: response}))
                    .catch(() => ({data: []}));
            }
        })
    })
});

export const {useGetPropertyEstimatedPricesQuery} = propertyEstimatedPricesApi;
import {appendQueryString, getExternalRequest} from "@pg-mono/request";
import {apiBigDataLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../../app/api/rp_api";
import {bigDataApiUrl} from "../../../app/read_rp_environment_variables";
import {IFetchPropertyEstimatedPriceRequestParams, IPropertyEstimatedPrice} from "../../../property/actions/fetch_property_estimated_price";

export type IGetPropertyEstimatedPricesQuery = Omit<IFetchPropertyEstimatedPriceRequestParams, "scenario" | "date_start" | "date_end"> & {
    date_start?: string;
    date_end?: string;
};

export const propertyEstimatedPricesApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getPropertyEstimatedPrices: builder.query<IPropertyEstimatedPrice[], IGetPropertyEstimatedPricesQuery>({
            queryFn: async (query) => {
                const fullQuery = {...query, scenario: "rp-price-avg"};
                const endpointLink = query.slug_district ? apiBigDataLink.monthDistrictsStats.base : apiBigDataLink.monthCityStats.base;
                const url = appendQueryString(endpointLink(bigDataApiUrl), fullQuery);

                return getExternalRequest({}, url, 5000)
                    .then((response: IPropertyEstimatedPrice[]) => ({data: response}))
                    .catch(() => ({data: []}));
            }
        })
    })
});

export const {useGetPropertyEstimatedPricesQuery} = propertyEstimatedPricesApi;
